import { render, staticRenderFns } from "./IndexBK.vue?vue&type=template&id=f8c13722&scoped=true&"
import script from "./IndexBK.vue?vue&type=script&lang=js&"
export * from "./IndexBK.vue?vue&type=script&lang=js&"
import style0 from "./IndexBK.vue?vue&type=style&index=0&id=f8c13722&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c13722",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VCard,VCardText,VDialog,VImg,VLayout,VProgressLinear})
